module.exports = __webpack_public_path__ + "img/voice of an echo.b746b41d.png";